import { motion, useReducedMotion } from "framer-motion";
import {
    defaultTransition,
    fadeUp,
    staggerContainer,
    viewport,
} from "@/lib/motionVariants";

export function StaggerReveal({ children, className }) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <motion.div
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
            variants={staggerContainer}
        >
            {children}
        </motion.div>
    );
}

export function StaggerItem({ children, className }) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <motion.div
            className={className}
            variants={fadeUp}
            transition={defaultTransition}
        >
            {children}
        </motion.div>
    );
}
